import React, { useEffect } from 'react';

import { AuthStatus } from 'scbk-services/auth/constants';
import { useAuthStatusStore } from 'scbk-services/auth/stores/authStatusStore';

const useAuthStatus = () => {
    const getAuthStatus = useAuthStatusStore((state) => state.getAuthStatus);
    const resetAuthStatus = useAuthStatusStore((state) => state.resetAuthStatus);
    const setAuthStatus = useAuthStatusStore((state) => state.setAuthStatus);

    const getStatus = (): AuthStatus => {
        return getAuthStatus();
    };

    const resetStatus = (): void => {
        resetAuthStatus();
    };

    const setStatus = (status: AuthStatus): void => {
        setAuthStatus(status);
    };

    const useSubscribeStatus = (
        callback: (status: AuthStatus) => void,
        dependencies: React.DependencyList = [],
    ) => {
        useEffect(() => {
            const unsubscribe = useAuthStatusStore.subscribe((state) => callback(state.status));
            return () => unsubscribe();
        }, [...dependencies]);
    };

    return { getStatus, resetStatus, setStatus, useSubscribeStatus };
};

export default useAuthStatus;
